module.exports = __webpack_public_path__ + "img/autoshow-slide-02.5611a3fe.png";